import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/shared";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { Workflow } from "lucide-react";
import RunsMonitor from "@/pages/journeys/RunsMonitor";

export default function Automations() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/automations").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  return (
    <div className="space-y-5">
      <PageHeader title="Automations" desc="Journeys running right now, plus legacy event → action rules." testId="automations-header" />
      <RunsMonitor embedded />
      <h3 className="font-semibold pt-2">Legacy rules</h3>
      {!items ? <Skeleton className="h-40 w-full" /> : items.length === 0 ? (
        <div className="bg-card border border-border rounded-lg"><EmptyState icon={Workflow} title="No automations yet"
          desc="Open a bot's Automations tab to create rules like: WHEN /start → send welcome message."
          action={<Button size="sm" onClick={() => navigate("/bots")}>Go to bots</Button>} testId="empty-automations-global" /></div>
      ) : (
        <div className="bg-card border border-border rounded-lg divide-y divide-border">
          {items.map((a) => (
            <button key={a.id} onClick={() => navigate(`/bots/${a.bot_id}`)} data-testid={`automation-${a.id}`} className="w-full flex items-center justify-between p-4 hover:bg-secondary/40 text-left">
              <div><div className="font-medium text-sm">{a.name}</div><div className="text-xs text-muted-foreground mono">WHEN {a.trigger} → {a.action}</div></div>
              <span className="text-xs mono text-muted-foreground">{a.runs} runs</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
